import { createApi } from '@reduxjs/toolkit/query/react'
import { NetWork } from '../../../common/apiKey'
import { GET } from '../../../common/contants'
import { axiosBaseQuery } from '../../baseQuery'

export const ledgerApi = createApi({
  reducerPath: 'ledgerApi',
  baseQuery: axiosBaseQuery,
  tagTypes: ['Ledger'],
  endpoints: (builder) => ({
    getListLedger: builder.query({
      query: (params) => ({
        url: NetWork.ledger,
        method: GET,
        params: params
      }),
      providesTags: (result) => (result ? [{ type: 'Ledger', id: 'LIST' }] : [])
    })
  })
})

export const { useGetListLedgerQuery } = ledgerApi
